// Integration quickbook Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Button from '../../../common/common/button/button.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'

class IntegrationQuickbook extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      connectUrl: PropTypes.string,
      onDisconnect: PropTypes.func,
      showConnected: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      connectUrl: '',
      onDisconnect: null,
      showConnected: false
    }
  }

  render () {
    const { title, connectUrl, onDisconnect, showConnected } = this.props

    const titleConvert = IntlUtil.convertMessage(
      'setting.integration.connectToTitle'
    )
    return (
      <div className='integration-quickbookitem'>
        <div className='content'>
          <h3 className='title'>
            <IntlMessage ident={title} />
          </h3>
          <div className='cont'>
            {!showConnected && (
              <a
                href={connectUrl || '#'}
                title={titleConvert}
                className='button button_save button_view quickbkconnect'
              >
                <span className='icon'>
                  <img
                    src='/images/common/qb_default.png'
                    className='inline-image'
                  />
                </span>
                <span className='icon hover'>
                  <img
                    src='/images/common/qb_hover.png'
                    className='inline-image'
                  />
                </span>
                <span className='title'>
                  <IntlMessage ident='setting.integration.connectToTitle' />
                </span>
              </a>
            )}
            {showConnected && (
              <Button
                className='button_save button_view'
                title='setting.integration.connectedTitle'
                canHover={false}
                type='button'
                icon='common-success-tick'
              />
            )}
          </div>
          {showConnected && (
            <div className='footercont'>
              <div className='applabel'>
                <IntlMessage ident='setting.integration.quickbookAppName' />
                <IconButton
                  type='primary'
                  icon='header-upload-delete'
                  canHover
                  className='act-avatar-delete'
                  onClick={onDisconnect}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default IntegrationQuickbook
